import { ChevronLeft, ChevronRight } from "lucide-react";

const VIEWS = [
  { key: "dayGridMonth", label: "Mese" },
  { key: "timeGridWeek", label: "Settimana" },
  { key: "timeGridDay", label: "Giorno" },
];

export function CalendarToolbar({ title, currentView, onPrev, onNext, onToday, onViewChange }) {
  return (
    <div className="card-surface p-4 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-2">
          <button onClick={onPrev} className="btn-secondary !px-2 !py-1.5" data-testid="calendar-prev">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={onToday} className="btn-secondary !py-1.5 text-xs" data-testid="calendar-today">Oggi</button>
          <button onClick={onNext} className="btn-secondary !px-2 !py-1.5" data-testid="calendar-next">
            <ChevronRight className="w-4 h-4" />
          </button>
          <h2 className="text-base font-semibold ml-2 capitalize" data-testid="calendar-current-title">{title}</h2>
        </div>
        <div className="flex items-center gap-1 bg-zinc-100 rounded-sm p-0.5">
          {VIEWS.map((v) => (
            <button key={v.key} onClick={() => onViewChange(v.key)} data-testid={`calendar-view-${v.key === "dayGridMonth" ? "month" : v.key === "timeGridWeek" ? "week" : "day"}`}
              className={`px-3 py-1.5 text-xs font-medium rounded-sm transition-colors ${currentView === v.key ? "bg-white text-[#002FA7] shadow-sm" : "text-zinc-500 hover:text-zinc-700"}`}>
              {v.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
